import * as React from 'react';

// set the defaults
const AppContext = React.createContext({
    // tslint:disable-next-line:no-empty
    setTitle: () => {}
});
export default AppContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/appContext.tsx